import React from 'react';
import { TemplateGalleryCard } from '@common/types';
import { TFunction } from '@wix/fe-essentials-standalone/i18n';
import s from '../TemplateCard.module.scss';

const TemplateCardLinkWrapper = ({
  template,
  children,
  templateHref,
  onClick,
  setHover,
  setFocused,
  t,
}: {
  t: TFunction;
  templateHref: string;
  onClick: () => void;
  template: TemplateGalleryCard;
  children: React.ReactNode;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
  setFocused: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div
      aria-labelledby={`template-title-${template.title}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false);
        template.media?.animatedPreview && setFocused(false);
      }}
    >
      <a
        data-hook={`template-card-container-${template.id}`}
        href={templateHref}
        aria-label={t('marketplace.templates-page.view-template-cta')}
        className={s.cardContainer}
        onClick={onClick}
      >
        {children}
      </a>
    </div>
  );
};

export default TemplateCardLinkWrapper;
